import React from 'react';

export default props => (
  <svg viewBox={props.viewBox || '0 0 25 25'} style={{ display: 'block', margin: '0 auto' }}>
    <g fill={props.color}>
      <path d="M14.46,5C11.82,5,9.55,6.55,8.5,8.79C7.96,8.43,7.31,8.21,6.61,8.21 c-1.79,0-3.25,1.38-3.38,3.13C1.35,12.01,0,13.79,0,15.89c0,2.66,2.16,4.82,4.82,4.82h15.71c2.47,0,4.46-2,4.46-4.46 c0-2.29-1.72-4.17-3.94-4.43c0-0.07,0.01-0.14,0.01-0.21C21.07,7.96,18.11,5,14.46,5" />
    </g>
  </svg>
);
